import { resolveCostPerUnitSurface, resolveOverallBudget } from "../lib/project";
import { ProjectGeneratedEntity } from "./generated/ProjectGeneratedEntity";

export abstract class ProjectEntity extends ProjectGeneratedEntity {
    public get estimatedOverallBudget(): number | null {
        return resolveOverallBudget(this.estimatedDemolitionBudget, this.estimatedConstructionBudget);
    }

    public get realOverallBudget(): number | null {
        return resolveOverallBudget(this.realDemolitionBudget, this.realConstructionBudget);
    }

    public get estimatedCostSurface(): number | null {
        const overallBudget = resolveOverallBudget(this.estimatedDemolitionBudget, this.estimatedConstructionBudget);
        return resolveCostPerUnitSurface(overallBudget, this.floorSurface);
    }

    public get realCostSurface(): number | null {
        const overallBudget = resolveOverallBudget(this.realDemolitionBudget, this.realConstructionBudget);
        return resolveCostPerUnitSurface(overallBudget, this.floorSurface);
    }

    public get isBugWorkflowEnabled(): boolean {
        return this.bugWorkflow != null;
    }
}
